// extracted by mini-css-extract-plugin
module.exports = {"gvItem":"GVItem_gvItem__oOLrB","value":"GVItem_value__AYt4U","rightButtons":"GVItem_rightButtons__67M34"};